module.exports = __webpack_public_path__ + "img/circled-arrow-right-orange.184c2220.svg";